import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-features-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_features_list_inner = _resolveComponent("product-features-list-inner")!
  const _component_read_more = _resolveComponent("read-more")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showMoreLink)
      ? (_openBlock(), _createBlock(_component_read_more, {
          key: 0,
          "text-more": "ads.main.detail.read_more",
          "text-less": "ads.main.detail.read_less",
          "max-height": _ctx.maxHeight,
          "scroll-less-element": `.${_ctx.scrollLessElement}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_product_features_list_inner, { features: _ctx.features }, null, 8 /* PROPS */, ["features"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["max-height", "scroll-less-element"]))
      : (_openBlock(), _createBlock(_component_product_features_list_inner, {
          key: 1,
          features: _ctx.features
        }, null, 8 /* PROPS */, ["features"]))
  ]))
}